import { BottomNavigation, BottomNavigationAction, styled, Fab } from "@mui/material"

import { Link, useNavigate, useLocation } from "react-router-dom"

import { ReactComponent as Home } from "static/svg/navigation/home.svg"
import { ReactComponent as HomeActive } from "static/svg/navigation/home_active.svg"
import { ReactComponent as Heart } from "static/svg/navigation/heart.svg"
import { ReactComponent as HeartActive } from "static/svg/navigation/heart_active.svg"
import { ReactComponent as History } from "static/svg/navigation/history.svg"
import { ReactComponent as HistoryActive } from "static/svg/navigation/history_active.svg"
import { ReactComponent as Account } from "static/svg/navigation/account.svg"
import { ReactComponent as AccountActive } from "static/svg/navigation/account_active.svg"
import { ReactComponent as Doctor } from "static/svg/navigation/doctor.svg"
import RtlIconWrapper from "../../shared/RtlIconWrapper"

const CustomBottomNavigationAction = styled(BottomNavigationAction)(() => ({
  borderRadius: "50%",
  minWidth: "auto", // Allow buttons to shrink to fit content
  transition: "background-color 0.3s", // Smooth transition for hover/active states
  "& .MuiBottomNavigationAction-label": {
    display: "none",
  },
  "&:not(.Mui-selected)": {
    paddingTop: "0", // Remove top padding for non-active buttons
  },
}))

const Navigation = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleChange = (event, newValue) => {
    navigate(newValue)
  }

  const path = location.pathname

  return (
    <BottomNavigation
      value={path}
      onChange={handleChange}
      sx={{
        position: "fixed",
        bottom: 25,
        left: 25,
        right: 25,
        height: "55px",
        borderRadius: "60px",
        maxWidth: "450px",
        margin: "auto",
        boxShadow: "0px 0px 40px 0px #1A2B4426",
      }}
    >
      <CustomBottomNavigationAction
        label="Home"
        value="/me"
        icon={path === "/me" ? <HomeActive /> : <Home />}
      />
      <CustomBottomNavigationAction
        label="Last screening"
        value="/me/last_screening"
        icon={path === "/me/last_screening" ? <HeartActive /> : <Heart />}
      />

      <Link to="/me/anamnesis">
        <Fab
          color="secondary"
          aria-label="start bot"
          sx={{
            position: "absolute",
            top: -15,
            width: 60,
            height: 60,
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <Doctor sx={{ color: "secondary.main" }} />
        </Fab>
      </Link>

      <CustomBottomNavigationAction disabled={true} />

      <CustomBottomNavigationAction
        label="History"
        value="/me/history_of_requests"
        icon={
          path === "/me/history_of_requests" ? (
            <RtlIconWrapper>
              <HistoryActive />{" "}
            </RtlIconWrapper>
          ) : (
            <RtlIconWrapper>
              <History />
            </RtlIconWrapper>
          )
        }
      />

      <CustomBottomNavigationAction
        label="Account"
        value="/me/personal_data"
        icon={path === "/me/personal_data" ? <AccountActive /> : <Account />}
      />
    </BottomNavigation>
  )
}

export default Navigation
